export default __webpack_public_path__ + "static/media/Angular.765139fa.png";